import { Box, Button, Flex, Grid, GridItem, Input, InputGroup, InputLeftElement, Modal, ModalContent, ModalOverlay, Text, } from '@chakra-ui/react';
import MyDiv from './memberIntraction.style';
import { CustomPagination, CustomToast } from '../../../components';
import { useEffect, useRef, useState } from 'react';
import { ILazyParams, useFetch } from '../../../hooks/useFetch';
import "suneditor/dist/css/suneditor.min.css";
import { Search2Icon } from '@chakra-ui/icons';
import { IFilterOptions } from '../../../components/FilterCard/filterCard';
import { MembersintractionList, MembersMailModal } from '../components';

const MemberIntraction = () => {
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [member, setMember] = useState<any[]>([]);
    const searchRef = useRef<HTMLInputElement>(null);
    const [totalCou, setTotalCou] = useState(0);
    const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });
    const [selectedFilters, setSelectedFilters] = useState<Record<string, number[]>>({});
    const [mailModalOpen, setMailModalOpen] = useState(false);
    const [selectedEmployees, setSelectedEmployees] = useState<any[]>([]);
    const [search, setSearch] = useState<string>('');
    const [debouncedSearch, setDebouncedSearch] = useState<string>('');

    const mailFormRef = useRef({ subject: "", message: "" });
    const [query, setQuery] = useState<{ lazyParams: ILazyParams & { filters?: Record<string, any> }; }>({
        lazyParams: {
            first: 0,
            rows: 20,
            page: 0,
            sortField: "",
            sortOrder: 1,
            filters: {},
        },
    });


    const handleSearch = (value: string) => {
        setSearch(value);
    };

    async function loadTeamFilter() {
        const response = await fetchApi<IFilterOptions>('Filters/TeamFilter', 'GET', null, null, '');
        if (response) {
            setFilter(response);
        }
    }

    async function loadTeamMembers() {
        const params = new URLSearchParams();

        params.set("first", String(query.lazyParams.first ?? 0));
        params.set("rows", String(query.lazyParams.rows ?? 20));
        params.set("sortOrder", String(query.lazyParams.sortOrder ?? 1));

        if (query.lazyParams.sortField) { params.set("sortField", query.lazyParams.sortField); }
        if (debouncedSearch.trim()) { params.set("globalFilter", debouncedSearch.trim()); }
        if (Object.keys(query.lazyParams.filters ?? {}).length > 0) {  params.set("filters", JSON.stringify(query.lazyParams.filters)); }

        const result = await fetchApi( `TeamInteraction/getMemlistbyEmpId?${params.toString()}`, "GET", null, null );
        if (result) {
            setMember(result.employee ?? result.data ?? []);
            setTotalCou(result.totalCount ?? 0);
        }
    }

    useEffect(() => {
        loadTeamFilter();
    }, [])

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000);

        return () => {
            clearTimeout(handler);
        };
    }, [search]);

    useEffect(() => {
        loadTeamMembers();
    }, [
        query.lazyParams.first,
        query.lazyParams.rows,
        query.lazyParams.sortField,
        query.lazyParams.sortOrder,
        query.lazyParams.filters,
        debouncedSearch,
    ]);



    const toggleRow = (row: any) => {
        setSelectedEmployees(prev => {
            const exists = prev.some(e => e.id === row.id);
            if (exists) {
                return prev.filter(e => e.id !== row.id);
            }
            return [...prev, row];
        });
    };

    const toggleAll = () => {
        if (
            member.length > 0 &&
            member.every(m =>
                selectedEmployees.some(s => s.id === m.id)
            )
        ) {
            setSelectedEmployees([]);
        } else {
            setSelectedEmployees(member);
        }
    };


    const sendMailApi = async () => {
        if (selectedEmployees.length === 0) {
            addToast({
                message: "Please select employees", status: "warning"
            });
            return;
        }

        if (!mailFormRef.current.subject.trim()) {
            addToast({
                message: "Subject is required", status: "warning"
            });
            return;
        }


        if (!mailFormRef.current.message.trim()) {
            addToast({
                message: "Message is required", status: "warning"
            });
            return;
        }

        const payload = {
            employeeIds: selectedEmployees.map(e => e.id),
            subject: mailFormRef.current.subject,
            message: mailFormRef.current.message
        };

        const response = await fetchApi(
            "TeamInteraction/sendMemberMeetingMailRequest",
            "POST",
            payload
        );

        if (response) {
            addToast({
                message: "Mail sent successfully", status: "success"
            });
            setSelectedEmployees([]);
            setMailModalOpen(false);
        }
    };

    const openMailModal = () => {
        mailFormRef.current = { subject: "", message: "" };
        setMailModalOpen(true);
    };


    return (
        <MyDiv>
            <Box className="page_wrapper flex_header">
                <Flex className="page_heading" align="center" justify="space-between" w="100%">
                    <Text className="font-poppins text_3xl text_semibold" whiteSpace="nowrap"> Team Interaction</Text>
                    <Flex gap={2}>
                        <InputGroup w="250px">
                            <InputLeftElement pointerEvents="none">
                                <Search2Icon color="rgba(102, 112, 133, 1)" />
                            </InputLeftElement>
                            <Input ref={searchRef} type="text" placeholder="Search employee name" onChange={(e) => handleSearch(e.target.value)} />
                        </InputGroup>
                        <Button colorScheme="green" isDisabled={selectedEmployees.length === 0} onClick={openMailModal}>
                            Send Mail ({selectedEmployees.length})
                        </Button>
                    </Flex>
                </Flex>

                {/* MemberIntraction List */}
                <Grid className='grid_container'>
                    <GridItem colSpan={12} pl={4} >
                        <MembersintractionList loading={loading} toggleAll={toggleAll} toggleRow={toggleRow} member={member} selectedEmployees={selectedEmployees} setSelectedEmployees={setSelectedEmployees} query={query} setQuery={setQuery} totalCount={totalCou}/>
                    </GridItem>
                </Grid>
            </Box>

            {/* Members Mail Modal */}
            <Modal isOpen={mailModalOpen} onClose={() => setMailModalOpen(false)} size="5xl">
                <ModalOverlay />
                <ModalContent>
                    <MembersMailModal loading={loading} sendMailApi={sendMailApi} mailFormRef={mailFormRef} />
                </ModalContent>

            </Modal>
        </MyDiv >
    );
};

export default MemberIntraction;